package pl.decks.personal.components.widgets.revealtext

data class RevealSentence(val text: String, val keep: Boolean = true) {
    val wordTokens = text.split(" ").mapIndexed { i, w -> if (i != 0) " $w" else w }
}
